import { useContext } from 'react';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputAdornment,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { ProdutosContext } from 'contexts/ProdutosContext';
import { DropsContext } from 'contexts/DropsContext';
import { useModal } from 'components/Modals';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';

const PrecoModal = ({ sum = 0, onSubmit }) => {
  const defaultValues = {
    celinha_id: null,
    cegrupo_id: null,
    moeda_id: null,

    cliente_id: null,
    vendedor_id: null,

    grupo_entidade_id: null,
    condicao_pagamento_id: null,
    tabpreco_id: null,

    preco: '',
  };
  const { closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { postLoading } = useContext(ProdutosContext);
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <>
      <DialogTitle>Confirmação da alteração</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DialogContentText>
              Você está alterando o preço de {sum} produto(s)
            </DialogContentText>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Filtros</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="celinha_id"
              control={control}
              label="Linha"
              options={drops?.LinhaProduto}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="cegrupo_id"
              control={control}
              label="Grupo"
              options={drops?.GrupoProduto}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="moeda_id"
              control={control}
              label="Moeda"
              options={drops?.Moeda}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <VirtualDrop
              name="cliente_id"
              control={control}
              label="Cliente"
              options={drops?.Entidade}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="vendedor_id"
              control={control}
              label="Vendedor"
              options={drops?.EntidadeTipo?.filter(
                (t) => t?.tipo === 'VENDEDOR' || t?.tipo === 'REPRESENTANTE'
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="grupo_entidade_id"
              control={control}
              label="Grupo"
              options={drops?.GrupoEntidade}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="condicao_pagamento_id"
              control={control}
              label="Condição de Pagamento"
              options={drops?.CondicaoPagamento}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="tabpreco_id"
              control={control}
              label="Tabela de Preço"
              options={drops?.TabelaPreco}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Preço</Typography>
          </Grid>
          <Grid item xs={12}>
            <InputMask
              name="preco"
              control={control}
              label="Preço"
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(onSubmit)}
          loading={postLoading}
        >
          Confirmar
        </Button>
        <Button variant="contained" color="secondary" onClick={closeModal}>
          Voltar
        </Button>
      </DialogActions>
    </>
  );
};

export default PrecoModal;
